module.exports = __webpack_public_path__ + "img/withholding_tax_definition.2aaaec17.png";